import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconVisibilityOutlineSvg } from "./IconVisibilityOutlineSvg.mjs";
const IconVisibilityOutline = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconVisibilityOutlineSvg, ...iconProps });
};
export {
  IconVisibilityOutline
};
